export const BLOGGERS = {
  mincurrency: {
    img: 'https://minfin.com.ua/img/userpics/1082870.jpg',
    name: 'Мінфін про Валюту',
    nick: 'mincurrency',
  },
  Minfin: {
    img: 'https://minfin.com.ua/img/userpics/1082870.jpg',
    name: 'Мінфін',
    nick: 'Minfin',
  },
};

export default BLOGGERS;
